import React from 'react';
import { Popconfirm, Row, Tooltip } from 'antd';
import { PiPencil } from 'react-icons/pi';
import { RiErrorWarningLine } from 'react-icons/ri';
import { Delete } from 'react-iconly';
import { Eye } from 'iconsax-react';
import { Link } from 'react-router-dom';
import { FiExternalLink } from 'react-icons/fi';
import IntlMessages from '../../../../../layout/components/lang/IntlMessages';
import urlPageTemplateDetails from '../../../../../urls/urlPageTemplateDetails';
import urlPageTemplatesVisualizationsDetails from '../../../../../urls/urlPageTemplatesVisualizationsDetails';
import { HasRights, PrivateComponent } from '../../../../../components/HasRights/HasRights';
import { Permissions } from '../../../../../const/permissions';
import getFormattedDate from '../../../../../lib/getFormattedDate';
import CollapsibleText from '../../../../../components/CollapsibleText';
import StatusTag from '../../../../../components/StatusTag';
import { DATE_TIME_FORMAT, EMPTY_VALUE_PLACEHOLDER } from '../../../../../const/system';



export const getTemplatesVisualizationsTableColumns = (handleEdit, handleDelete, tableSize) => [
  {
    title: <IntlMessages id="ui-general-id" />,
    dataIndex: 'id',
    align: 'center',
    width: tableSize.width * 0.08,
    sorter: true,
  },
  {
    title: <IntlMessages id="ui-general-title" />,
    dataIndex: 'title',
    width: tableSize.width * 0.12,
    align: 'center',
    render: (item) => <CollapsibleText text={item} maxLength={200} />,
  },
  {
    title: <IntlMessages id="ui-general-template" />,
    align: 'center',
    width: tableSize.width * 0.14,
    render: (item) => {
      return (
        HasRights([ Permissions.CONSTRUCTORS.TEMPLATES.FIND ]) ? (
          <Link style={{ wordBreak: 'break-all' }} to={urlPageTemplateDetails({ templateId: item?.template_id })} target="_blank">
            {item?.template_name ?? EMPTY_VALUE_PLACEHOLDER}
            <FiExternalLink size={14} className="hp-ml-4" />
          </Link>
        ) : (
          <div>{item?.template_name ?? EMPTY_VALUE_PLACEHOLDER}</div>
        )
      );
    },
  },
  {
    title: <IntlMessages id="ui-general-default" />,
    align: 'center',
    dataIndex: 'is_default',
    width: tableSize.width * 0.10,
    render: (value) => <StatusTag active={Boolean(value)} />,
  },
  {
    title: <IntlMessages id="ui-general-created-at" />,
    dataIndex: 'created_at',
    align: 'center',
    sorter: true,
    width: tableSize.width * 0.12,
    render: (value) => getFormattedDate(value, DATE_TIME_FORMAT),
  },
  {
    title: <IntlMessages id="ui-general-updated-at" />,
    dataIndex: 'updated_at',
    align: 'center',
    sorter: true,
    width: tableSize.width * 0.12,
    render: (value) => getFormattedDate(value, DATE_TIME_FORMAT),
  },
  ...(HasRights([
    Permissions.CONSTRUCTORS.TEMPLATES.VISUALIZATIONS.VIEW,
    Permissions.CONSTRUCTORS.TEMPLATES.VISUALIZATIONS.EDIT,
    Permissions.CONSTRUCTORS.TEMPLATES.VISUALIZATIONS.DELETE,
  ]) ?
    [ {
      title: <IntlMessages id="ui-general-action" />,
      key: 'action',
      align: 'center',
      width: tableSize.width * 0.13,
      render: (item) => {
        return (
          <Row className="da-h-100" align="middle" justify="center">
            <PrivateComponent allowedPermissions={[ Permissions.CONSTRUCTORS.TEMPLATES.VISUALIZATIONS.VIEW ]}>
              <Tooltip placement="top" title={<IntlMessages id="ui-general-view" />}>
                <div className="hp-text-right">
                  <Link
                    to={urlPageTemplatesVisualizationsDetails({ visualizationId: item.id })}
                    target="_blank"
                  >
                    <Eye
                      size={20}
                      data-testid="view-icon"
                      className="hp-cursor-pointer hp-transition hp-hover-text-color-warning-1 hp-text-color-black-80 hp-m-4"
                    />
                  </Link>
                </div>
              </Tooltip>
            </PrivateComponent>

            <PrivateComponent allowedPermissions={[ Permissions.CONSTRUCTORS.TEMPLATES.VISUALIZATIONS.EDIT ]}>
              <Tooltip placement="top" title={<IntlMessages id="ui-general-edit" />}>
                <div className="hp-text-right">
                  <PiPencil
                    onClick={() => handleEdit(item.id)}
                    size={20}
                    data-testid="edit-icon"
                    className="hp-cursor-pointer hp-transition hp-hover-text-color-warning-1 hp-text-color-black-80 hp-m-4"
                  />
                </div>
              </Tooltip>
            </PrivateComponent>

            <PrivateComponent allowedPermissions={[ Permissions.CONSTRUCTORS.TEMPLATES.VISUALIZATIONS.DELETE ]}>
              <Popconfirm
                title={<IntlMessages id="ui-general-delete-confirm-message" />}
                placement="topLeft"
                onConfirm={() => handleDelete(item.id)}
                okText={<IntlMessages id="ui-general-yes" />}
                cancelText={<IntlMessages id="ui-general-no" />}
                icon={<RiErrorWarningLine className="remix-icon hp-text-color-primary-1" />}
                okButtonProps={{ danger: true }}
              >
                <Tooltip placement="top" title={<IntlMessages id="ui-general-delete" />}>
                  <div className="hp-text-right">
                    <Delete
                      size={20}
                      data-testid="delete-icon"
                      className="hp-cursor-pointer hp-transition hp-hover-text-color-danger-1 hp-text-color-black-80 hp-m-4"
                    />
                  </div>
                </Tooltip>
              </Popconfirm>
            </PrivateComponent>
          </Row>
        );
      },
    } ] : []
  ),
];

